import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { EnOnlyNote } from './EnOnlyNote';
import { useChromeT } from '../lib/i18n';

const PRODUCT_SLUGS = ['auto', 'home', 'life', 'business', 'commercial_auto', 'umbrella', 'renters', 'medicare'];

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [, t] = useChromeT();
  const note = t('en_only_note');

  return (
    <footer className="section-dark py-12" data-testid="site-footer">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <Logo size="small" />
            </div>
            <p className="text-gray-300 mb-2 italic">{t('ft_slogan')}</p>
            <p className="text-gray-300 mb-4 text-sm">{t('ft_desc')}</p>
            <div className="flex flex-col space-y-2">
              <a
                href="mailto:Herecomesprotection@gmail.com"
                className="text-accent-orange hover:text-rust-amber transition-colors"
              >
                📧 Herecomesprotection@gmail.com
              </a>
              <span className="text-gray-400 text-sm">herecomesprotection.com</span>
            </div>
            <p className="text-xs text-gray-400 mt-4 italic">{t('ft_privacy_note')}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('ft_quick_links')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-300 hover:text-accent-orange transition-colors">{t('ft_home')}<EnOnlyNote text={note} /></Link></li>
              <li><Link to="/protection-center" className="text-gray-300 hover:text-accent-orange transition-colors">{t('nav_protection_center')}<EnOnlyNote text={note} /></Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-accent-orange transition-colors">{t('nav_about')}<EnOnlyNote text={note} /></Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-accent-orange transition-colors">{t('nav_contact')}<EnOnlyNote text={note} /></Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-accent-orange transition-colors">{t('ft_privacy')}<EnOnlyNote text={note} /></Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('ft_coverage')}</h4>
            <ul className="space-y-2 text-sm">
              {PRODUCT_SLUGS.map((slug) => (
                <li key={slug}>
                  <Link
                    to={`/protection-center/start/${slug}`}
                    className="text-gray-300 hover:text-accent-orange transition-colors"
                  >
                    {t(`cov_${slug}`)}<EnOnlyNote text={note} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              <p>&copy; {currentYear} Here Comes Protection. {t('ft_rights')}</p>
            </div>
            <div className="flex items-center space-x-4">
              <Link to="/privacy" className="text-gray-400 hover:text-accent-orange transition-colors text-sm">
                {t('ft_privacy')}<EnOnlyNote text={note} />
              </Link>
            </div>
          </div>

          <div className="mt-4 text-xs text-gray-500 space-y-1">
            <p>{t('ft_disc_1')}</p>
            <p>{t('ft_disc_2')}</p>
            <p>{t('ft_disc_3')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
